import { render } from "./YourDocumentsPage.vue?vue&type=template&id=089fe1a2"
import script from "./YourDocumentsPage.vue?vue&type=script&lang=js"
export * from "./YourDocumentsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__